<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="py-5 mt-3 mb-4 container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mb-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"border-radius:25px;"' class=" p-5 shadow bg-white " >
                <template #default>لطفا آموزش مورد نظر خود را انتخاب کنید     </template>
                </m-h1></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container-fluid " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"padding-bottom: 200px;"' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 mb-4" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/saratavakoli-master.ir\/pages\/%D8%A2%D9%85%D9%88%D8%B2%D8%B4-%D8%B1%DB%8C%D9%85%D9%88%D9%88","target":"_self"},...{}}' :style='""' class="d-inline" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.saratavakoli-master.ir\/storage\/banners\/re,move.jpg","alt":""},...{}}' :style='"border-radius:25px;"' class="w-100 shadow p-0 m-0" ></m-img></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 mb-4" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/saratavakoli-master.ir\/pages\/%D8%A2%D9%85%D9%88%D8%B2%D8%B4-%DA%86%D8%B4%D9%85","target":"_self"},...{}}' :style='""' class="d-inline" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.saratavakoli-master.ir\/storage\/banners\/cheshm.jpg","alt":""},...{}}' :style='"border-radius:25px;"' class="w-100 shadow p-0 m-0" ></m-img></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 mb-4" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/saratavakoli-master.ir\/pages\/%D8%A2%D9%85%D9%88%D8%B2%D8%B4-%D9%84%D8%A8","target":"_self"},...{}}' :style='""' class="d-inline" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.saratavakoli-master.ir\/storage\/banners\/lips (2).jpg","alt":""},...{}}' :style='"border-radius:25px;"' class="w-100 shadow p-0 m-0" ></m-img></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 mb-4" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/saratavakoli-master.ir\/pages\/%D8%A2%D9%85%D9%88%D8%B2%D8%B4-%D8%A7%D8%A8%D8%B1%D9%88","target":"_self"},...{}}' :style='""' class="d-inline" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.saratavakoli-master.ir\/storage\/banners\/abroo.jpg","alt":"mix it web"},...{}}' :style='"border-radius:25px;"' class="w-100 shadow p-0 m-0" ></m-img></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mA,mImg },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
